<template>
  <div>
    <h3 class="is-size-5 has-text-weight-medium has-text-centered">
      {{ $t('resourceNotificationsCreateModal.form.title') }}
    </h3>

    <div class="pb-4">
      <classic-input
        v-model="value.title"
        :label="$t('resourceNotificationsCreateModal.form.title_label')"
        model-id="title"
        @input="onChangeInput"
      />
      <p v-if="!isTitleValid" class="has-text-danger is-size-7">
        {{ $t('resourceNotificationsCreateModal.form.title_error') }}
      </p>
    </div>

    <div v-if="resourceImages.length > 0" class="pb-4">
      <p class="has-border-bottom has-text-weight-medium">
        {{ $t('resourceNotificationsCreateModal.form.images_title') }}
      </p>

      <div class="resource-images mt-2 pb-2">
        <div v-for="image in resourceImages" :key="image.id" class="image-box">
          <label class="checkbox">
            <auth-image
              :src="image.url_thumb || image.url"
              borders
            />
            <input
              v-model="value.medium_ids"
              :value="image.id"
              class="checkbox"
              type="checkbox"
              @change="onChangeInput"
            />
          </label>
        </div>
      </div>
    </div>

    <div v-if="resourceFullText" class="pb-4">
      <label class="checkbox has-border-bottom is-flex">
        <input
          v-model="value.include_text"
          class="checkbox"
          type="checkbox"
          @change="onChangeInput"
        />
        <span class="ml-2 has-text-weight-medium">
          {{ $t('resourceNotificationsCreateModal.form.text_title') }}
        </span>
      </label>
      <text-editor
        :value="resourceFullText"
        :highlight-words="[]"
        model-id="full_text_body"
        class="mt-2 has-borders p-2 resource-text-body"
        placeholder=""
        read-only
      />
    </div>

    <div class="pb-4">
      <label class="checkbox has-border-bottom is-flex">
        <input
          v-model="value.include_metadata"
          class="checkbox"
          type="checkbox"
          @change="onChangeInput"
        />
        <span class="ml-2 has-text-weight-medium">
          {{ $t('resourceNotificationsCreateModal.form.metadata_title') }}
        </span>
      </label>
      <table class="mt-2 is-size-7 table is-fullwidth is-borderless is-narrow">
        <tbody>
          <tr v-for="(fieldValue, fieldKey) in visibleMetadataFields" :key="fieldKey">
            <td>{{ $t(`resourceForm.labels.metadatum.${fieldKey}`) }}:</td>
            <td>{{ [fieldValue].flat().join(', ') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { resourceFullText, visibleMetadataFields, resourceImages } from './utils'

const TextEditor = () => import('@/components/ResourceForm/TextEditor.vue')
const ClassicInput = () => import('@/components/ResourceForm/ClassicInput.vue')
const AuthImage = () => import('@/components/commons/AuthImage/Single.vue')

export default {
  name: 'ResourceNotificationsCreateForm',
  components: { TextEditor, ClassicInput, AuthImage },
  props: {
    value: {
      type: Object,
      required: true
    },
    resource: {
      type: Object,
      required: true
    }
  },
  emits: ['input'],
  computed: {
    resourceFullText() {
      return resourceFullText(this.resource)
    },
    visibleMetadataFields() {
      return visibleMetadataFields(this.resource)
    },
    resourceImages() {
      return resourceImages(this.resource)
    },
    isTitleValid() {
      return !!this.value.title && String(this.value.title).trim().length > 0
    }
  },
  methods: {
    onChangeInput() {
      this.$emit('input', { ...this.value })
    }
  }
}
</script>
<style>
.resource-text-body {
  max-height: 300px;
  overflow-y: scroll;
}

.resource-images {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
}

.resource-images .image-box {
  margin: 0 12px;
  width: 25%;
  min-width: 25%;
}

.resource-images > label.checkbox {
  position: relative;
}

.image-box input.checkbox {
  position: absolute;
  bottom: 6px;
  right: 6px;
}

.resource-images .image-box:first-child {
  margin-left: 0;
}

.resource-images .image-box:last-child {
  margin-right: 0;
}
</style>